var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductPp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42 45",
    style: {
      enableBackground: "new 0 0 42 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.ppp{fill:#6576FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ppp",
    d: "M38.6,9.2L24,0.8c-1.9-1.1-4.2-1.1-6.1,0L3.4,9.2c-1.9,1.1-3,3.1-3,5.2v16.8c0,2.2,1.2,4.2,3,5.2L18,44.9 c0.1,0,0.1,0.1,0.2,0.1l-3.8-8.3c-1.1-3-1-5.5,0.1-7.7c1.2-2.2,3.2-3.8,6.3-4.9l6-2.2c0.7-0.3,1.3-0.8,1.6-1.5 c0.3-0.7,0.3-1.4,0.1-2.1c-0.3-0.7-0.7-1.3-1.4-1.6c-0.7-0.3-1.4-0.4-2.1-0.1L9.1,22.3l-2.3-6.4l15-5.5c1.7-0.6,3.3-0.9,4.7-0.9 c1.4,0,2.7,0.3,3.8,0.9c1.1,0.5,2,1.3,2.8,2.2c0.8,1,1.4,2.1,1.8,3.3c0.4,1.1,0.6,2.3,0.7,3.5c0,1.2-0.2,2.4-0.6,3.5 c-0.5,1.1-1.2,2.2-2.3,3.2c-1,1-2.4,1.8-4.2,2.4l-6.2,2.3c-0.7,0.3-1.2,0.7-1.4,1.5c-0.3,0.7-0.3,1.4,0,2.2l4.4,9.8l13.3-7.7 c1.9-1.1,3-3.1,3-5.2V14.5C41.6,12.3,40.5,10.3,38.6,9.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPp);
export default __webpack_public_path__ + "static/media/product-pp.b17e9813e381c21de04e067a4efd61e4.svg";
export { ForwardRef as ReactComponent };